<script setup lang="ts">
type Emits = {
  retry: [];
  close: [];
};

const emit = defineEmits<Emits>();
</script>

<template>
  <div class="deposit-denied text-center">
    <div
      class="flex flex-row items-center gap-3 cursor-pointer mb-4"
      @click="emit('close')"
    >
      <NuxtIcon
        class="text-auth-texts/80"
        name="arrows/arrow_left"
      />
      <span class="text-auth-texts font-semibold text-base">
        {{ $t('deposit.general.go_back') }}
      </span>
    </div>

    <div class="check-circle mx-auto mt-3">
      <svg
        aria-hidden="true"
        fill="none"
        height="26"
        viewBox="0 0 16 16"
        width="26"
      >
        <path
          d="M3 3l10 10M13 3L3 13"
          stroke="#FB4E6D"
          stroke-linecap="round"
          stroke-width="2"
        />
      </svg>
    </div>

    <h5 class="text-auth-texts font-bold text-xl mt-4 mb-2">
      {{ $t('account.wallet.deposit_denied.title') }}
    </h5>

    <p class="text-auth-texts/80 mb-4 px-2">
      {{ $t('account.wallet.deposit_denied.subtitle') }}
    </p>

    <div class="alert alert-warning flex items-center gap-2 text-left">
      <NuxtIcon
        class="shrink-0"
        name="toaster/warning"
      />
      {{ $t('account.wallet.deposit_denied.tip') }}
    </div>

    <button
      class="btn-retry mt-6"
      type="button"
      @click="emit('retry')"
    >
      {{ $t('account.wallet.deposit_denied.retry') }}
    </button>

    <button
      class="text-auth-texts/60 text-sm mt-4"
      type="button"
      @click="emit('close')"
    >
      {{ $t('account.wallet.deposit_denied.close') }}
    </button>
  </div>
</template>

<style scoped lang="scss">
.deposit-denied {
  .check-circle {
    @apply flex items-center justify-center rounded-full bg-error/10;
    width: 76px;
    height: 76px;
  }

  .btn-retry {
    @apply rounded-md font-medium text-lg bg-auth-button-deposit-bg text-auth-button-deposit-text w-full px-3 py-3 cursor-pointer;
  }
}
</style>
